// @flow
import every from 'lodash/every'
import get from 'lodash/get'
import some from 'lodash/some'
import type { Answer } from 'types/answer'
import type { Question } from 'types/question'
import { hasText } from 'utils/helpers'

function getTableRows(answers: Array<Answer>, question: Question) {
  const rowsWithAnswers = answers?.reduce((acc, answer) => {
    if (
      (answer.questionId === question.id || answer.question === question.id) &&
      !acc.includes(answer.question_row)
    ) {
      if (answer.question_row) {
        // this condition is separate from the one above so that flow can understand it
        return [...acc, answer.question_row]
      }
    }

    return acc
  }, [])

  const questionRowIds = question.question_rows.map((row) => row.id)

  return [...new Set([...rowsWithAnswers, ...questionRowIds])]
}

function getTableColumns(answers: Array<Answer>, question: Question) {
  return answers?.reduce((acc, answer) => {
    if (
      (answer.questionId === question.id || answer.question === question.id) &&
      answer.question_column &&
      !acc.includes(answer.question_column)
    ) {
      return [...acc, answer.question_column]
    }
    return acc
  }, [])
}

function assertAllRowsAndColumnsAreFilled(
  table_rows: Array<number>,
  answers: Array<Answer>,
  question: Question
) {
  return every(table_rows, (row) => {
    return every(question.question_columns, (col) => {
      return some(answers, (answer) => {
        return (
          answer.question_row === row &&
          answer.question_column === col.id &&
          hasText(answer.text_value)
        )
      })
    })
  })
}

function validateTableQuestion(
  answers: Array<Answer>,
  question: Question
): boolean | void {
  const q_subtype = get(question, 'question_type.question_subtype')
  const table_rows = getTableRows(answers, question)
  const table_cols = getTableColumns(answers, question)
  if (q_subtype !== 'open_ended') return
  if (!table_rows.length || !table_cols.length) return false

  return assertAllRowsAndColumnsAreFilled(table_rows, answers, question)
}

export default validateTableQuestion
